import { onPremEnabled } from 'src/utils/utils';

let isOnPremDeployment = false;

export const loadIsOnPremDeployment = async () => {
  isOnPremDeployment = await onPremEnabled();
};

export const getIsOnPremDeployment = () => isOnPremDeployment;
